// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"a1541f0f","379":"befc55d7","678":"52f8d9e0","735":"b70ef1c4","899":"677f411c","900":"30817e25","905":"7ad43f3a"}[chunkId] + ".chunk.js";
};